import { useMediaQuery, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import React, { FC } from 'react';

const PageTitle: FC<{ leftAlign?: boolean }> = ({ children, leftAlign }) => {
	const theme = useTheme();
	const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
	const matchUpLg = useMediaQuery(theme.breakpoints.up('lg'));
	let variant: any = 'h4';
	if (matchUpLg) {
		variant = 'h2';
	} else if (matchUpMd) {
		variant = 'h3';
	}
	return (
		<Typography variant={variant} align={leftAlign ? 'left' : 'center'}>
			{children}
		</Typography>
	);
};

export default PageTitle;
